import logo from "../Assets/logo-sem_fundo.png";
import slogan from "../Assets/slogan.png";
import mulherCorrendo from "../Assets/mulher correndo.png";
import testeLab from "../Assets/testelaboratorio.png";
import fotoPriscila from "../Assets/fotopriscila.png";
import fotoZair from "../Assets/fotozair.png";
import mulherpordosol from "../Assets/mulherpordosol.png";
import mulhertreinando from "../Assets/mulher treinando.png";
// import slogansobreNos from "../Assets/slogan-sobre-nos.png";
import slogansobreNos from "../Assets/slogan quem somos(2).png";

export const Logo = logo;
export const Slogan = slogan;
export const MulherCorrendo = mulherCorrendo;
export const TestLab = testeLab;
export const FotoPriscila = fotoPriscila;
export const FotoZair = fotoZair;
export const MulherCorrendoPorDoSol = mulherpordosol;
export const MulherTreinando = mulhertreinando;
export const sloganSobreNos = slogansobreNos;
